import ApiClient from '@services/ApiClient';

export default {
    search(params) {
        return ApiClient.get('/travel/fat/search', {
            params,
        });
    },

    checkIfPossible(params) {
        return ApiClient.get('/travel/fat/check-if-possible', {
            params,
        });
    },

    validateSearch(data) {
        return ApiClient.post('/travel/fat/validate-search', data);
    },

    travelOptionPrices(id) {
        return ApiClient.get(`/travel/fat/${id}/travel-option-prices`);
    },
};
